import { instance } from '.';

export const getComentarioPrivadoById = async (id) => {

    const resp = await instance.get(`/comentariosprivados/${id}`);
    return resp.data;
}

export const getComentariosPrivadosByTareaId = async (id) => {

    const resp = await instance.get(`/comentariosprivados/GetByTareaId/${id}`);
    return resp.data;
}

export const getComentariosPrivadosByOferta = async (id) => {

    const resp = await instance.get(`/comentariosprivados/GetByOferta/${id}`);
    return resp.data;
}


export const postComentarioPrivado = async (comentario) => {
    const resp = await instance.post('/comentariosprivados', comentario);
    return resp;

}

export const putComentarioPrivado = async (comentario) => {

    const resp = await instance.put(`/comentariosprivados/${comentario.id}`, comentario);
    return resp;

}

export const deleteComentarioPrivado = async (id) => {

    const resp = await instance.delete(`/comentariosprivados/${id}`);
    return resp;

}
